// Pagamento parcial da retirada fica no navegador (decisão do dono, 24/09):
// nada vai pro caixa até a última parte, e fechar/recarregar a página não
// perde o que o cliente já pagou. Chave por pedido; guarda o total para
// descartar se o pedido foi editado depois.
const chave = (pedidoId) => `nucleo_fechamento_pedido_${pedidoId}`;

export function lerConta(pedido) {
  try {
    const bruto = localStorage.getItem(chave(pedido.id));
    if (!bruto) return null;
    const salvo = JSON.parse(bruto);
    return Math.abs(Number(salvo.total) - Number(pedido.total)) < 0.005 ? salvo.conta : null;
  } catch {
    return null;
  }
}

export function gravarConta(pedido, conta) {
  try {
    localStorage.setItem(chave(pedido.id), JSON.stringify({ total: pedido.total, conta }));
  } catch {
    // navegador sem armazenamento: segue só em memória
  }
}

export function apagarConta(pedidoId) {
  try {
    localStorage.removeItem(chave(pedidoId));
  } catch {
    // idem
  }
}
